import { render } from "./bestBagCombination.vue?vue&type=template&id=5deabfe4&scoped=true&ts=true"
import script from "./bestBagCombination.vue?vue&type=script&lang=ts"
export * from "./bestBagCombination.vue?vue&type=script&lang=ts"

import "./bestBagCombination.vue?vue&type=style&index=0&id=5deabfe4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5deabfe4"]])

export default __exports__